/* Oh!My Snacks — Loja interactions
   - Quick-filter chips: AJAX-load filtered grid without page reload
   - Add-to-cart on product card → button morphs into [- qty +] stepper
   - Stepper +/- updates cart line; reaching 0 reverts to "Adicionar" button
   - On page load, syncs steppers with current cart state
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getSectionId(root) {
    // The section root has id="oms-catalogue-<shopify-section-id>"
    var m = (root.id || '').match(/^oms-catalogue-(.+)$/);
    return m ? m[1] : null;
  }

  function setBusy(root, busy) {
    var grid = root.querySelector('.oms-catalogue__grid');
    if (!grid) return;
    grid.style.opacity = busy ? '0.45' : '';
    grid.style.pointerEvents = busy ? 'none' : '';
    grid.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function fetchAndSwap(root, url, push) {
    var sectionId = getSectionId(root);
    if (!sectionId) {
      // Fallback: regular navigation
      window.location.href = url;
      return;
    }
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = url + sep + 'section_id=' + encodeURIComponent(sectionId);

    setBusy(root, true);

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Shopify returns the section wrapper. Find our equivalent nodes inside.
        var newGrid = doc.querySelector('.oms-catalogue__grid');
        var newResults = doc.querySelector('.oms-catalogue__toolbar .results');
        var newToolbar = doc.querySelector('.oms-catalogue__toolbar');

        var curGrid = root.querySelector('.oms-catalogue__grid');
        var curResults = root.querySelector('.oms-catalogue__toolbar .results');
        var curToolbar = root.querySelector('.oms-catalogue__toolbar');

        if (newGrid && curGrid) curGrid.innerHTML = newGrid.innerHTML;
        if (newResults && curResults) curResults.innerHTML = newResults.innerHTML;
        // Keep current sort dropdown selection in sync if Shopify rendered a new toolbar
        if (newToolbar && curToolbar) {
          var newSort = newToolbar.querySelector('select[name="sort_by"]');
          var curSort = curToolbar.querySelector('select[name="sort_by"]');
          if (newSort && curSort) curSort.value = newSort.value;
        }

        if (push) {
          window.history.pushState({ oms: true, url: url }, '', url);
        }
      })
      .catch(function () {
        // Network error → just navigate normally
        window.location.href = url;
      })
      .finally(function () {
        setBusy(root, false);
      });
  }

  ready(function () {
    document.querySelectorAll('.oms-catalogue').forEach(function (root) {
      // Chip clicks → AJAX load
      var chipRow = root.querySelector('.oms-chip-row');
      if (chipRow) {
        chipRow.addEventListener('click', function (e) {
          var chip = e.target.closest('.oms-chip');
          if (!chip) return;
          var href = chip.getAttribute('href');
          if (!href || href === '#') return; // no link configured → ignore
          e.preventDefault();
          // Visual active state
          chipRow.querySelectorAll('.oms-chip').forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          // Fetch + swap
          fetchAndSwap(root, href, true);
          // Scroll to top of catalogue softly
          var top = root.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      }

      // Sort change → AJAX load (keeps current URL, just updates ?sort_by=)
      var sortForm = root.querySelector('.oms-sort-control');
      if (sortForm) {
        var sortSelect = sortForm.querySelector('select[name="sort_by"]');
        if (sortSelect) {
          // Prevent form's onchange="this.form.submit()" from doing a full submit
          sortSelect.removeAttribute('onchange');
          sortSelect.addEventListener('change', function () {
            var url = new URL(window.location.href);
            url.searchParams.set('sort_by', sortSelect.value);
            fetchAndSwap(root, url.pathname + url.search, true);
          });
        }
        sortForm.addEventListener('submit', function (e) { e.preventDefault(); });
      }
    });

    // Back/forward navigation
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.oms) {
        document.querySelectorAll('.oms-catalogue').forEach(function (root) {
          fetchAndSwap(root, e.state.url, false);
        });
      }
    });

    // ===== Cart: quantity stepper + add =====
    // Robust cart count updater: reads the authoritative item_count from
    // /cart.js and writes it into Sense's bubble — creating the bubble if it
    // doesn't exist yet (Sense omits it when the cart is empty).
    function findCartLink() {
      return document.querySelector('#cart-icon-bubble')
        || document.querySelector('a[href$="/cart"]')
        || document.querySelector('a[href*="/cart"]');
    }
    function updateCartCount() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
          if (count === null) return;

          // Prefer Sense's existing bubble(s) — update in place, never duplicate.
          var existing = document.querySelectorAll('.cart-count-bubble');
          if (existing.length) {
            existing.forEach(function (bubble) {
              if (count > 0) {
                var span = bubble.querySelector('span[aria-hidden="true"]');
                if (span) { span.textContent = count; }
                else { bubble.textContent = count; }
                bubble.style.display = '';
                bubble.hidden = false;
              } else {
                bubble.style.display = 'none';
              }
            });
            return;
          }

          // Other themes: generic count nodes.
          var nodes = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count');
          if (nodes.length) {
            nodes.forEach(function (el) { el.textContent = count; });
            return;
          }

          // No bubble anywhere yet (empty cart in Sense) — create one inside the cart link.
          if (count > 0) {
            var link = findCartLink();
            if (link) {
              var b = document.createElement('div');
              b.className = 'cart-count-bubble';
              b.innerHTML = '<span aria-hidden="true">' + count + '</span>';
              link.appendChild(b);
            }
          }
        })
        .catch(function () {});
    }
    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().catch(function () { return {}; }); });
    }
    function variantId(card) {
      var v = card.getAttribute('data-variant-id');
      return v ? parseInt(v, 10) : null;
    }
    function cardQty(card) {
      var el = card.querySelector('[data-qty]');
      return el ? Math.max(1, parseInt(el.textContent, 10) || 1) : 1;
    }

    // Delegated handlers
    document.addEventListener('click', function (e) {
      // Quantity − / +
      var down = e.target.closest('[data-qty-down]');
      var up = e.target.closest('[data-qty-up]');
      if (down || up) {
        e.preventDefault();
        e.stopPropagation();
        var card0 = (down || up).closest('[data-product-card]');
        var qtyEl = card0.querySelector('[data-qty]');
        var cur = parseInt(qtyEl.textContent, 10) || 1;
        var next = down ? Math.max(1, cur - 1) : Math.min(99, cur + 1);
        qtyEl.textContent = next;
        return;
      }
      // Add to cart with chosen quantity
      var addBtn = e.target.closest('[data-add-to-cart]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        var card = addBtn.closest('[data-product-card]');
        var vid = variantId(card);
        if (!vid) return;
        var qty = cardQty(card);
        var original = addBtn.textContent;
        addBtn.disabled = true;
        postJSON('/cart/add.js', { id: vid, quantity: qty })
          .then(function () {
            updateCartCount();
            document.dispatchEvent(new CustomEvent('oms:cart:updated'));
            addBtn.textContent = 'Adicionado ✓';
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1400);
          })
          .catch(function () { addBtn.disabled = false; });
      }
    });
  });
})();
